// SearchService.js
import { getAuth } from "firebase/auth";
import Vacancy from "../models/Vacancy";

const SEARCH_BASE_URL = "https://europe-west3-hyper-e122e.cloudfunctions.net";

class SearchService {
  /**
   * Поиск вакансий по текстовому запросу
   * @param {string} query — поисковый запрос пользователя
   * @returns {Promise<Vacancy[]>} — массив вакансий, приведённых к модели Vacancy
   */
  static async searchVacancies(query = "") {
    try {
      const auth = getAuth();
      const currentUser = auth.currentUser;

      if (!currentUser) {
        console.error("❌ Пользователь не авторизован");
        throw new Error("Пользователь не авторизован");
      }

      // Получаем ID токен
      const token = await currentUser.getIdToken(true);
      if (!token) throw new Error("❌ Не удалось получить токен Firebase");

      // Формируем параметры запроса
      const queryParams = new URLSearchParams();
      if (query.trim()) queryParams.append("q", query.trim());

      const url = `${SEARCH_BASE_URL}/search_vacancies?${queryParams.toString()}`;
      console.log("🔍 Запрос поиска:", url);

      // Отправляем запрос
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("🚨 Ошибка ответа сервера:", errorText);
        throw new Error(`Ошибка поиска: ${response.status}`);
      }

      // Парсим результат
      const result = await response.json();
      console.log(`✅ Найдено ${result.total ?? 0} вакансий`);

      // Нормализуем каждую вакансию через модель Vacancy
      const vacancies = (result.vacancies || []).map((v) => Vacancy.fromJson(v));

      console.groupCollapsed("🔎 Результаты поиска:");
      console.table(
        vacancies.map((v) => ({
          id: v._id,
          title: v.title,
          company: v.company_name,
          city: v.city_id,
        }))
      );
      console.groupEnd();

      return vacancies;
    } catch (error) {
      console.error("🚨 Ошибка в searchVacancies:", error.message || error);
      return [];
    }
  }
}

export default SearchService;